(ns com.theplantscape.plant-web.draw.modals
  (:require
   [com.theplantscape.plant-web.api.plants :refer [fetch-plant]]
   [com.theplantscape.plant-web.components.search :as c]
   [com.theplantscape.plant-web.draw.actions :refer [configure-tool]]
   [com.theplantscape.local-store.ensemble
    :refer [add-new-plant fetch-plant-eid-from-uuid]]
   [com.theplantscape.plant-web.draw.state
    :refer
    [app-state hide-modal set-mode]]))

(defn lookup-plant->add-to-db [{:keys [id type] :as plant}]
  (prn "lookup")
  (fetch-plant id prn))

(defn search-modal [{:keys [id type] :as plant}]
  (prn (str "search modal " id))
  (lookup-plant->add-to-db plant)
  (hide-modal)
  (add-new-plant plant)
  (set-mode :insert type)
  #_(prn (fetch-plant-eid-from-uuid id))
  (swap! app-state assoc-in [:current :plant] (fetch-plant-eid-from-uuid id))
  #_(prn (-> @app-state :current :plant)))

(defn select-plant-modal []
  (configure-tool
   :insert
   [c/ui-plant-search c/search-modal]))


